// index.js or your store file
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore } from 'redux-persist';
import { thunk as ReduxThunk } from 'redux-thunk';
import RootReducer from './reducers';

const store = createStore(RootReducer, compose(applyMiddleware(ReduxThunk)));
persistStore(store);

export default store;